<div class="adf-metadata-properties">
  <mat-accordion displayMode="flat" [multi]="multi">
    <mat-expansion-panel
      *ngIf="displayDefaultProperties"
      [expanded]="canExpandProperties()"
      [attr.data-automation-id]="'adf-metadata-group-properties'"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'CORE.METADATA.BASIC.HEADER' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <adf-card-view
        (keydown)="keyDown($event)"
        [properties]="basicProperties$ | async"
        [editable]="editable"
        [displayEmpty]="displayEmpty"
        [copyToClipboardAction]="copyToClipboardAction"
        [useChipsForMultiValueProperty]="useChipsForMultiValueProperty"
        [multiValueSeparator]="multiValueSeparator"
      >
      </adf-card-view>
    </mat-expansion-panel>

    <ng-container *ngIf="expanded">
      <ng-container
        *ngIf="groupedProperties$ | async; else loading; let groupedProperties"
      >
        <div
          *ngFor="let group of groupedProperties; let first = first"
          class="adf-metadata-grouped-properties-container"
        >
          <mat-expansion-panel
            *ngIf="showGroup(group) || editable"
            [attr.data-automation-id]="'adf-metadata-group-' + group.title"
            [expanded]="
              canExpandTheCard(group) || (!displayDefaultProperties && first)
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ group.title | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <adf-card-view
              (keydown)="keyDown($event)"
              [properties]="group.properties"
              [editable]="editable"
              [displayEmpty]="displayEmpty"
              [copyToClipboardAction]="copyToClipboardAction"
              [useChipsForMultiValueProperty]="useChipsForMultiValueProperty"
              [multiValueSeparator]="multiValueSeparator"
            >
            </adf-card-view>
          </mat-expansion-panel>
        </div>
      </ng-container>
      <ng-template #loading>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
    </ng-container>

    <mat-expansion-panel
      *ngIf="editable"
      [expanded]="expandMediaProperties()"
      [attr.data-automation-id]="'adf-metadata-group-media-properties'"
    >
      <mat-expansion-panel-header
        (click)="mediaProperties.clearValue(); togglePanel($event)"
        (keyup)="mediaProperties.clearValue(); togglePanel($event)"
      >
        <mat-panel-title>
          {{ 'CORE.METADATA.MEDIA_PROP.HEADER' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <wk-media-properties
        #mediaProperties
        [mediaType]="mediaType.toUpperCase()"
        [editable]="editable"
      ></wk-media-properties>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="adf-metadata-action-buttons" *ngIf="editable">
    <button
      class="wk-button wk-button-ghost"
      (click)="cancelAllChanges()"
      (keyup.enter)="cancelAllChanges()"
      data-automation-id="reset-metadata"
      [disabled]="!hasMetadataChanged"
    >
      {{ 'CORE.METADATA.ACTIONS.CANCEL' | translate }}
    </button>
    <button
      class="wk-button wk-button-small"
      (click)="saveChanges()"
      (keyup.enter)="saveChanges()"
      color="primary"
      data-automation-id="save-metadata"
      [disabled]="!hasMetadataChanged"
    >
      {{ 'CORE.METADATA.ACTIONS.SAVE' | translate }}
    </button>
  </div>
</div>
